import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SB2610 from "../pages/sb2610/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/texas-sb-2610",
    element: <SB2610 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
